var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpencode = function SvgOpencode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 240 300"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#opencode_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "opencode_svg__b",
    width: 240,
    height: 300,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M240 0H0v300h240z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#opencode_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFCECD",
    d: "M180 240H60V120h120z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211E1E",
    d: "M180 60H60v180h120zm60 240H0V0h240z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "opencode_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h240v300H0z"
  })))));
};
export default SvgOpencode;